import Controller from "csi/action/Controller";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import { CallMethod } from "csi/xml/CallMethod";
import xml from	"csi/xml";
import array from "dojo/_base/array";
import declare from	"dojo/_base/declare";
import _ from "underscore";

const MassSelectProductHierarchy = declare([Controller, ActionControllerMixin], {

	/**
	* @override
	* Prepare the data and pass it into the next page
	*/
	onNextPage(wizard, currentPage, nextPage, bFinish) {
		this.m_formData.m_bRequireOne = true;
		return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (wizard.getIndexOfPage(nextPage) == 1));
	},

	toWriterRequest() {
		const call = this.inherited<CallMethod>(arguments);
		const fd = this.m_formData;

		const nodes = fd.getSelectedNodes();
		const targetFolder = fd.getFields().pop();
		if (nodes?.length) {
			call.addParameter(xml.PROP_AGGREGATE_ADDS, xml.ATTR_REFLIST, array.map(nodes, xml.nodeGetURL));
		}
		call.addParameter("ProductHierarchyFolder", xml.ATTR_REF, targetFolder.getValue());

		return call;
	},

	/**
	* @override
	* Refresh table data
	*/
	postProcessSuccess() {
		this.widget.refreshData();
	},
});

export = MassSelectProductHierarchy;
